<template>
  <div id="login">
    <div>
      <el-container>
        <el-main>

          <p class="welcome">欢迎登录</p>
          <el-form :model="loginForm" status-icon class="login-form">
            <el-form-item>
              <el-input v-model="loginForm.username">
                <template slot="prepend">用户名</template>
              </el-input>
            </el-form-item>
            <el-form-item>
              <el-input type="password" v-model="loginForm.password">
                <template slot="prepend">密码</template>
              </el-input>
            </el-form-item>
            <el-form-item>
              <el-button class="login-btn" :loading="isLoading" type="primary" @click="submitForm()">登录</el-button>
            </el-form-item>
          </el-form>
        </el-main>
        <el-footer>
          <p>备案号：<a :href="sysConfig.recordLink">{{sysConfig.recordNo}}</a>&nbsp;&nbsp;{{sysConfig.copyrightEn}}</p>
          <p>{{sysConfig.copyrightCn}}</p>
        </el-footer>
        <!-- <el-footer>
          <p>备案号：<a href="https://beian.miit.gov.cn">苏ICP备19011731号</a>&nbsp;&nbsp;Copyright2021 MUME Co.Ltd</p>
          <p>版权所有：南京木美传媒科技有限公司</p>
        </el-footer> -->
      </el-container>
    </div>
    <div>
      <div class="logo">
        <!-- <img :src="sysConfig.homepageLogo || '../assets/mume_logo.png'"> -->
        <p>{{sysConfig.sysName}}</p>
        <div>
          <span>智慧</span>
          <span>循环</span>
          <span>高效</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import utils from "../utils/utils"
	import {mapMutations} from 'vuex'
  import request from '../utils/httpRequest'
  export default {
    name: 'login',
    data () {
      return {
        setting:{},
        loginForm:{
          username:"",
          password:"",
          validCode:""
        },
        isLoading: false,
        sysConfig:{
          sysName:"",
          homepageLogo:"../assets/mume_logo.png"
        }
      }
    },
    created(){
      this.getSysConfig()
    },
    methods:{
			...mapMutations(['userLogin']),
      getSysConfig(){
        // request.get("/api/sysConfig/query").then(res => {
        //     if(res.data.code == 0){
        //       this.sysConfig.sysName =  res.data.obj.sysName ? res.data.obj.sysName:"卡券回收管理系统平台"
        //       this.sysConfig.homepageLogo = res.data.obj.homepageLogo
        //       document.title = res.data.obj.shareTitle ? res.data.obj.shareTitle:this.sysConfig.sysName
        //       if(res.data.obj.shareLogo){
        //         var link = document.querySelector("link[rel*='icon']") || document.createElement('link');
        //         link.type = 'image/x-icon';
        //         link.rel = 'shortcut icon';
        //         link.href = res.data.obj.shareLogo;
        //         document.getElementsByTagName('head')[0].appendChild(link);
        //       }
        //     }
        //   });
        request.get("/api/sysConfig/getSysConfigByType?type=2").then(res => {
          if (res.data.code == 0) {
            this.sysConfig = res.data.obj;
            this.sysConfig.sysName = res.data.obj.sysName
              ? res.data.obj.sysName
              : "木美会员权益管理";
            this.sysConfig.homepageLogo = res.data.obj.homepageLogo;
            document.title = res.data.obj.shareTitle
              ? res.data.obj.shareTitle
              : this.sysConfig.sysName;
            if (res.data.obj.shareIcon) {
              var link = document.querySelector('link[rel*="icon"]')
              link.href = res.data.obj.shareIcon;
            }
          }
        });
      },
      submitForm(){
        let success = (response) => {
          if(response.data.code === 0){
            let obj = response.data.obj;
            let user = response.data.obj.user;
            this.setCookie("loginName",user.loginName ? user.loginName : user.userName,1)
            this.setCookie("actualName",user.actualName ? user.actualName : "平台管理超级用户",1)
            this.setCookie("headPic",user.headPic?user.headPic:"",1)
            this.setCookie("companyName",obj.companyName?obj.companyName:"",1)
            this.setCookie("deptName",obj.deptName?obj.deptName:"",1)
            this.setCookie("companyId",user.companyId?user.companyId:"",1)
            this.setCookie("userId",user.id)
            this.setCookie("createId",user.createId)
            this.setCookie("deptId",user.deptId)
            this.userLogin(Object.assign({},user))
            this.$router.replace({path:"/index"})
          }else{
            this.$message.error(response.data.msg)
          }
        }
        const that = this;
        this.isLoading =true;
        request.post('/api/user/login',this.loginForm).then(res=>{
          success(res);
        }).catch(e=>{
          that.isLoading = false;
          if(e && e.msg)
           this.$message.error(e.msg)
        })
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
#login{
  height: 100%;
  overflow: hidden;
  display: flex;
  min-width: 1200px;
  >div:nth-child(1){
    flex: 3;
  }
  >div:nth-child(2){
    flex: 2;
    background: url("../assets/login_bg.png") no-repeat center;
    background-size: 100% 100%;
    position: relative;
    .logo{
      height: 200px;
      width: 200px;
      position: absolute;
      top:60%;
      left: 50%;
      margin-top: -100px;
      margin-left: -100px;
      text-align: center;
      color: #ffffff;
      img{
        width: 110px;
        height: 110px;
      }
      p{
        font-size: 18px;
        font-weight: bold;
      }
      div{
        span{
          margin:0 10px;
        }
      }
    }
  }
  section{
    height: 100%;
    overflow: hidden;
    .el-header, .el-footer {
      color: #333;
      text-align: center;
    }
    .el-header{
      text-align: left;
      font-size: 24px;
      font-weight: bold;
      line-height: 60px;
      background-color: #0073a3;
      color: #fff;
    }
    .el-footer{
      background-color: #eeeeee;
      p{
        padding:0;
        margin:0;
        font-size: 14px;
        line-height: 30px;
      }
    }
    .el-main {
      background-color: #fff;
      color: #333;
      text-align: center;
      height:calc(100% - 120px);
      min-height: 400px;
      .welcome{
        line-height: 50px;
        width: 100px;
        margin: 25% auto 30px auto;
        border-bottom: solid 2px #409EFF;
        font-size: 24px;
        font-weight: bold;
      }
      .login-form{
        width: 400px;
        margin: 0 auto;
        .login-btn{
          width: 100%;
        }
      }
    }
  }

}
</style>
<style lang="less">
  #login{
    .el-input-group__prepend{
      width: 60px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/login.vue